import axios from "axios";
import { ordersServicesPath} from "../../../../Constants";

const issuanceRestUrl = ordersServicesPath + '/organizations/issuance'

export default class IssuanceService {

    static async getAllByMaterialWarehouseIdWithIssuingEdgeItem(materialWarehouseId) {
        return axios.get(issuanceRestUrl + '/by-material-warehouse-id' + '?materialWarehouseId=' + materialWarehouseId);
    }

    static async getAllWithFilter(pageNumber, pageSize, startIssue, finishIssue, startWrittenOff, finishWrittenOff) {
        const params = {
            page: pageNumber,
            pageSize: pageSize,
            startIssue: startIssue,
            finishIssue: finishIssue,
            startWrittenOff: startWrittenOff,
            finishWrittenOff: finishWrittenOff,
        };

        const queryString = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');
        return axios.get(`${issuanceRestUrl}/filter?${queryString}`)
    }

    static async getAllByMaterialWarehouseIdByIssuingEdgeItem(issuingEdgeId, materialWarehouseId) {
        return axios.get(issuanceRestUrl + '/' + issuingEdgeId + '/by-material-warehouse-id' + '?materialWarehouseId=' + materialWarehouseId);
    }

    static
    async getAllByMaterialReserveIdWithIssuingEdgeItem(materialReserveId) {
        return axios.get(issuanceRestUrl + '/by-material-reserve-id' + '?materialReserveId=' + materialReserveId);
    }

    static
    async getAllByIssuingEdgeItemId(issuingEdgeItemId) {
        return axios.get(issuanceRestUrl + '/by-issuing-edge-item-id' + '?issuingEdgeItemId=' + issuingEdgeItemId);
    }

    static async getInWork(localDateTime) {
        return axios.get(issuanceRestUrl + '/in-work' + '?localDateTime=' + localDateTime);
    }

    static async getInStock(localDateTime) {
        return axios.get(issuanceRestUrl + '/in-stock' + '?localDateTime=' + localDateTime);
    }

    static async update(id, quantity) {
        return axios.patch(`${issuanceRestUrl}/${id}/update?quantity=${quantity}`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}